import React from "react";
import styled from "styled-components";
import {ReactComponent as DownloadIcon} from "assets/icons/download.svg";
import {ReactComponent as DOCXIcon} from 'assets/icons/file-icon-docx.svg';
import {ReactComponent as PDFIcon} from 'assets/icons/file-icon-pdf.svg';
import {ReactComponent as PPTIcon} from 'assets/icons/file-icon-ppt.svg';
import {ReactComponent as TXTIcon} from 'assets/icons/file-icon-txt.svg';
import {ReactComponent as VideoIcon} from 'assets/icons/file-icon-video.svg';
import theme from 'styles/theme';
import {convertBytesToString} from "../../../utils/btyesString";

const BlurredDownloadContainer = styled.div`
  display: flex;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(.jpg);
  border-radius: 15px 15px 5px 15px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  justify-content: center;
  align-items: center;
  & svg{
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }
`

const ImagePreviewContainer = styled.a`
  max-width: 240px;
  width: fit-content;
  height: inherit;
  overflow: hidden;
  position: relative;
  ${p => p.sender === 'client' ? `float: right;`:'float:left'}
  ${p => p.sender === 'client' ? `border-radius: 15px 15px 0px 15px;`:`border-radius: 15px 15px 15px 0px;`}
  ${p => p.sender === 'client' ? `border: 2px solid ${p. userSettingColor ? p. userSettingColor.headerBackgroundColor : theme.palette.primary};`:'border: 2px solid #EDF0F7;'}
  ${p => p.preview === true ? `opacity: 0.5;`:''}
  &:hover ${BlurredDownloadContainer}{
    opacity: 1;
  }
  &:hover svg{
    opacity: 1;
  }
`

const ImageViewer = styled.img`
  width: 100%;
  height: 100%;
`

const DownloadIconHolder = styled.div`
  justify-self: flex-end;
  margin-right: 10px;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
`;

const FileContainer = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 5px;
  max-width: 240px;
  border-radius: 15px 15px 5px 15px;
  background: ${p => p.sender === "client" ? `${p.userSettingColor ? p. userSettingColor.headerBackgroundColor : theme.palette.primary}`:`#EDF0F7`};
  &:hover ${DownloadIconHolder}{
    opacity: 1;
  }
  &:hover{
    cursor: pointer;
  }
`

const FileIconHolder = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  ${p => p.sender === 'client' ? 'background: rgba(255, 255, 255, 0.2);' : 'background: rgba(209, 212, 220, 0.5);'};
`;


const FileDetailsContainer = styled.div`
    color: ${p => p.fill};
    margin-left: 8px;
  margin-right: 12px;
`;

const FileNameText = styled.div`
  font-size: 14px;
  line-height: 17px;
  max-height: 15px;
  max-width: 154px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
`;

const FileSizeText = styled.div`
  font-size: 10px;
  line-height: 12px;
  opacity: 0.5;
`;

const AttachmentMessageContainer = styled.div`
  //${p => (p.itemType==="jpg" || p.itemType==="png" || p.itemType==="gif") ? ``:`background: ${p.userSettingColor ? p.userSettingColor.headerBackgroundColor : theme.palette.primary}`};
  ${p => (p.itemType==="jpg" || p.itemType==="png" || p.itemType==="gif") ? `max-width: 240px; min-width: 100px; max-height: 240px; min-height: 100px`:``};
  float: ${p => p.sender === "client" ? 'right' : 'left'};
`

const AttachmentMessage = ({message, sender, userSettingColor, onLoad}) => {
    const {attachments} = message;
    let item = null;
    if(Array.isArray(attachments) && attachments.length === 1) item = attachments[0];
    else if(typeof attachments === "object") item = attachments;

    const getUrl = item => {
        if(item.publicUrl) return item.publicUrl;
        if(item.url) return item.url;
        if(item.assemblyUrl) return item.assemblyUrl;
    }

    const fill = sender === 'client' ? (userSettingColor.headerTextColor || '#FFFFFF') : '#525F76';
    return (
        item && (
            <AttachmentMessageContainer sender={sender} itemType={item.type} userSettingColor={userSettingColor}>
                {(item.type === "jpg" || item.type === "png" || item.type ==="gif" || item.type === "jpeg") &&
                    <ImagePreviewContainer userSettingColor={userSettingColor} sender={sender} url={getUrl(item)} preview={message.preview} href={getUrl(item)} download={item.name}>
                        <ImageViewer onLoad={onLoad} sender={sender} src={getUrl(item)} preview={message.preview}/>
                        <BlurredDownloadContainer>
                            <DownloadIcon fill={userSettingColor.headerTextColor || "#FFFFFF"}/>
                        </BlurredDownloadContainer>
                    </ImagePreviewContainer>
                }
                {(item.type === "pdf" || item.type === "txt" || item.type === "ppt" || item.type === "docx" || item.type === "mp4" || item.type === "mov") &&
                    <FileContainer sender={sender} userSettingColor={userSettingColor} href={getUrl(item)} download={item.name}>
                        <FileIconHolder sender={sender}>
                            {item.type === "pdf" && <PDFIcon fill={fill}/>}
                            {item.type === "txt" && <TXTIcon fill={fill}/>}
                            {item.type === "ppt" && <PPTIcon fill={fill}/>}
                            {item.type === "docx" && <DOCXIcon fill={fill}/>}
                            {(item.type === "mp4" || item.type === "mov") && <VideoIcon fill={fill}/>}
                        </FileIconHolder>
                        <FileDetailsContainer fill={fill}>
                            <FileNameText>{item.name}</FileNameText>
                            <FileSizeText>{convertBytesToString(item.size)}</FileSizeText>
                        </FileDetailsContainer>
                        <DownloadIconHolder>
                            <DownloadIcon fill={fill}/>
                        </DownloadIconHolder>
                    </FileContainer>
                }
            </AttachmentMessageContainer>
        )
    )

}

export default AttachmentMessage;